var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-index-bar',{attrs:{"index-list":Object.keys(_vm.cities)}},_vm._l((_vm.cities),function(item,index){return _c('div',{key:index},[_c('van-index-anchor',{attrs:{"index":index}}),_vm._l((item),function(i){return _c('van-cell',{key:i,attrs:{"title":i},on:{"click":function($event){return _vm.handleClick(i)}}})})],2)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }